import React from 'react'
import { Divider, Typography } from 'antd'
import GSM_BinStatus from '../../../components/GSuperMarket/GSM_BinStatus/GSM_BinStatus'

const GSM_BinStatusPage = ({ userData }) => {
    return (
        <>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}
            >
                <Typography.Title
                    level={5}
                    style={{
                        margin: 0,
                    }}
                >
                    Bin Status
                </Typography.Title>
            </div>
            <Divider style={{ marginTop: 8 }} />
            <GSM_BinStatus />
        </>
    )
}

export default GSM_BinStatusPage